import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {getSignedIn} from "./reducks/users/selectors";
import {listenAuthState} from "./reducks/users/operations";

const Auth = ({children}) => {
    const dispatch = useDispatch();
    const selector = useSelector((state) => state);

    const isSignedIn = getSignedIn(selector)

    useEffect(() => {
        if (!isSignedIn) {
            dispatch(listenAuthState())
        }
    }, []);

    // NOTE:ログイン前提のアプリにすれば、ログインが必要なコンポーネントのみ
    // Authで囲って、ログインがいらないコンポーネントは手前に出せば楽だった
    // メインページの表示をログインとそうでない時で変えたかったから仕方ないのか？
    if (!isSignedIn) {
        return [children[0], children[1]]
    } else {
        return [children[2], children[3]]
    }
};

export default Auth;